module.exports = __webpack_public_path__ + "img/background_Image_1.25fe43f9.png";